import { useMemo } from 'react'
import { map } from 'lodash'

import { sectionsMap } from '@/components/sections'

import { WPPageData } from '@/types'

export type BuilderProps = {
  pageProps?: WPPageData
}

const Builder = ({ pageProps }: BuilderProps) => {
  const builder = useMemo(() => pageProps?.acf?.builder || [], [pageProps])

  return map(builder, ({ acf_fc_layout, ...section }, index) => {
    const Component = sectionsMap[acf_fc_layout]

    const safeSection = acf_fc_layout === 'banner' ? section.banner : section

    return Component ? (
      <Component
        data-layout={acf_fc_layout}
        key={`${acf_fc_layout}-${index}`}
        theme={safeSection?.theme || 'light'}
        // product_hero ha gia' l'h1 della pagina
        {...(acf_fc_layout === 'image_hero' && pageProps?.type === 'product'
          ? { titleComponent: 'h2' }
          : {})}
        {...safeSection}
      />
    ) : null
  })
}

export default Builder
